import { render, staticRenderFns } from "./verification.vue?vue&type=template&id=059b119c&scoped=true&"
import script from "./verification.vue?vue&type=script&lang=js&"
export * from "./verification.vue?vue&type=script&lang=js&"
import style0 from "./verification.vue?vue&type=style&index=0&id=059b119c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059b119c",
  null
  
)

export default component.exports